:host {
  outline: none;
}

:host > .container {
  --background-color-list-element: var(--color-surface01);
  --background-hover-color-list-element: var(--color-background);
  --background-active-color-list-element: var(--color-background);

  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  font-family: var(--font-family-sans);
  font-weight: var(--font-rg);
  outline: none;
}

/* z-list-element size */

:host([size="small"]) > .container {
  min-height: calc(var(--space-unit) * 4);
  padding: calc(var(--space-unit) / 2) 0;
}

:host([size="medium"]) > .container {
  min-height: calc(var(--space-unit) * 5);
  padding: var(--space-unit) 0;
}

:host([size="large"]) > .container {
  min-height: calc(var(--space-unit) * 7);
  padding: calc(var(--space-unit) * 2) 0;
}

:host([size="x-large"]) > .container {
  min-height: calc(var(--space-unit) * 9);
  padding: calc(var(--space-unit) * 3) 0;
}

/* ----------------- */

:host([expandable]) > .container,
:host([clickable]) > .container {
  cursor: pointer;
}

:host([expandable]:hover) > .container,
:host([clickable]:hover) > .container {
  background-color: var(--background-hover-color-list-element);
}

:host([expandable]:focus:focus-visible) > .container,
:host([clickable]:focus:focus-visible) > .container {
  box-shadow: var(--shadow-focus-primary);
}

:host([clickable]:not([expandable])) > .container.clicked {
  box-shadow: var(--shadow-focus-primary);
}

:host([expandable]:active) > .container,
:host([clickable]:active) > .container {
  background-color: var(--background-active-color-list-element);
}

:host([align-button="left"][expandable]) > .container > .z-list-element-container {
  display: flex;
}

:host([align-button="right"][expandable]) > .container > .z-list-element-container {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
}

:host([align-button="left"][expandable]) > .container > .z-list-element-container > z-icon {
  margin-right: var(--space-unit);
}

:host([align-button="right"][expandable]) > .container > .z-list-element-container > z-icon {
  margin-left: var(--space-unit);
}

:host > .container > .z-list-element-inner-container {
  display: none;
}

:host > .container > .z-list-element-inner-container.expanded {
  display: block;
}

.z-list-content-container {
  display: flex;
  align-items: center;
}
